export const PROJECT_LIST = [
  {
    title: 'Lincoln Center Infoscape',
    imgSrc: require('../ProjectPages/assets/LincolnCenter/lc_logo.png'),
    pgSrc: '/lincoln-center',
    description: 'Branding & Motion Design',
  },
  {
    title: 'C7 Nova',
    imgSrc: require('../ProjectPages/assets/C7/speakers.mp4'),
    pgSrc: '/c7',
    description: 'Motion & 3D Design',
  },
  {
    title: 'Quilt',
    imgSrc: require('../ProjectPages/assets/Quilt/animatedlogo.mp4'),
    timeStart: 0,
    pgSrc: '/quilt',
    description: 'Branding & Product Design',
  },
  {
    title: 'Motion Reel',
    imgSrc: require('../ProjectPages/assets/MotionReel/2022MotionReel.mp4'),
    pgSrc: '/motion-reel',
    timeStart: 13,
    timeEnd: 23,
    description: 'Motion Design',
  },
];
